/* Copyright (c) 2017 Backpack Health LLC */
/* global window */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import AppUtils from '../../../../utilities/AppUtils';

import { Title2 } from '../../../components/Text';
import { LargePreferredLanguageDropdownList } from '../../../components/LanguageDropdownList';
import PublicShareCardFooter from '../PublicShareCard/PublicShareCardFooter';

import './PasscodeEntry.scss';
import { IconWarning } from '../../../components/icons/IconWarning';
import { TextLink } from '../../../components/TextLink';
import { Markdown } from '../../../components/Markdown';
import { useUIState } from '../../../hooks/useUIState';

const FORMATTED_VENDOR_NAME = {
  stickyj: 'StickyJ',
};

interface Props {
  hash?: string;
  messagePhraseId?: string;
  pageTitlePhraseId?: string;
  titlePhraseId?: string;
  contactVendor?: string;
  isMarkdown?: boolean;
}
const Invalid = (props: Props) => {
  const { contactVendor, isMarkdown } = props;
  const hash = props.hash || '';
  const messagePhraseId = props.messagePhraseId || 'shareCardURLInvalid.shareCard.message.text';
  const titlePhraseId = props.titlePhraseId || 'shareCardURLInvalid.title.text';
  const [, uiStateActions] = useUIState();

  React.useEffect(() => {
    const pageTitlePhraseId = props.pageTitlePhraseId || 'shareCardURLInvalid.page.title';
    uiStateActions.setWindowTitlePhrase({ id: pageTitlePhraseId });
  }, []);

  const link = contactVendor ? FORMATTED_VENDOR_NAME[contactVendor] : (
    <FormattedMessage id="shareCard.url.full.url" values={{ string1: AppUtils.getShareUrlSubdomainPrefix(), string2: hash }}>
      {(url) => <TextLink style={{ verticalAlign: 'initial' }} className="font-color-white" href={url}>{url}</TextLink>}
    </FormattedMessage>
  );

  return (
    <div className="page-passcode invalid">
      <div className="page-passcode-controls">
        <LargePreferredLanguageDropdownList htmlId="pageLanguage" color="white" showSelectedFullName />
      </div>

      <div className="page-passcodemain">
        <div className="page-passcodemain-content font-color-white">
          <Title2>
            <FormattedMessage id={titlePhraseId} />
          </Title2>

          <div style={{ marginTop: 14, maxWidth: 500, textAlign: 'center' }} className="font-body">
            {
              isMarkdown ? (
                <Markdown
                  id="invalid-msg"
                  phraseId={messagePhraseId}
                  phraseValues={{ string1: link }}
                  color="inherit"
                  underlineLinks={true}
                />
              ) : (
                <FormattedMessage id={messagePhraseId} />
              )
            }
          </div>

          <div style={{ marginTop: 55 }}>
            <IconWarning />
          </div>
        </div>
      </div>

      <PublicShareCardFooter white />
    </div>
  );
};

export default Invalid;
